import { render, staticRenderFns } from "./PauseControl.vue?vue&type=template&id=68ce31f7&scoped=true&"
import script from "./PauseControl.vue?vue&type=script&lang=js&"
export * from "./PauseControl.vue?vue&type=script&lang=js&"
import style0 from "./PauseControl.vue?vue&type=style&index=0&id=68ce31f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ce31f7",
  null
  
)

export default component.exports